<template>
    <div class="fulldashboard">
        <div class="dashboardinactiv">
            <h1 class="screenCenter">baoo Statistics coming soon</h1>
        </div>
        <div class="dashboardContainer">
            <div class="header">Dashboard</div>
            <div class="filter">letzten 28 Tage</div>
            <div class="kpiContainer topProduct">
                <div class="splitContainer">
                    <div class="kpiHeader">Top Produkt</div>
                    <div class="kpiClicks"> {{ clicks }} Klicks</div>
                </div>
                <div class="splitContainer">
                    <img class="productImageSize" src="@/assets/maggiProduct.jpg"/>
                </div>
            </div>

            <div class="kpiContainer">
                <div class="kpiHeaderNormal">Alle Impressionen</div>
                <div class="kpi">{{ impressions }}</div>
                <div class="kpiVariation">+ {{ impressionVariation }}% </div>
            </div>
            <div class="kpiContainer">
                <div class="kpiHeaderNormal">Navigationen zum Produkt</div>
                <div class="kpi">{{ navigations }}</div>
                <div class="kpiVariation">+ {{ navigationVariation }}% </div>
            </div>
            <div class="kpiContainer">
                <div class="kpiHeaderNormal">aktive Händler</div>
                <div class="kpi">{{ activRetailer }}</div>
                <div class="kpiVariation">+ {{ activRetailerVariation }}% </div>
            </div>
            <div class="statisticContainer">
                <div class="kpiHeaderNormal">Impressionen</div>
                <div class="kpiDescription">So häufig wurden Ihre Produkte in der Suche angezeigt</div>
                <div class="statisticOutput">
                    <img class="statisticImage" src="@/assets/dashboard/dashboardDummy.png"/>
                </div>
            </div>
            <div class="statisticContainer">
                <div class="kpiHeaderNormal">Händlerverteilung</div>
                <div class="kpiDescription">12 Händler in Köln</div>
                <div class="statisticOutput">
                    <img class="statisticImage" src="@/assets/dashboard/mapDashboardDummy.png"/>
                </div>
            </div>
            <div class="statisticContainer">
                <div class="kpiHeaderNormal">Zielgruppe</div>
                <div class="containerSplit">
                    <div class="splitHeaderLeft">weiblich</div>
                    <div class="splitHeaderRight">männlich</div>
                </div>
                <div class="distribute">
                    <div class="splitHeaderLeft">56%</div>
                    <div class="splitHeaderRight">44%</div>
                </div>
                <div class="containerSplit">
                    <div class="splitHeaderLeft">ø Alter</div>
                </div>
                <div class="distribute">
                    <div class="splitHeaderLeft">28</div>
                </div>
                <div class="containerSplit">
                    <div class="splitHeaderLeft">Interessen</div>
                </div>
                <div class="interestsDashboard">
                    <img class="dummy" src="@/assets/dashboard/interessenDummy.png"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    export default {
        name: "Dashboard",

        computed: {
            ...mapGetters(['user'])
        },
        data() {
            return {
                    clicks: "255",
                    impressions: "8784",
                    impressionVariation: "18",
                    navigations: "240",
                    navigationVariation: "24",
                    activRetailer: "17",
                    activRetailerVariation: "12"
            }
        }
    }
</script>

<style scoped>
    .header{
        padding-left: 15px;
        float: left;
        display: block;
    }
    .filter{
        padding-right: 15px;
        text-align: right;
        display:block;
    }
    .dashboardContainer{
        display: table;
        margin: 0 auto;
        
        border-radius:10px;
        
        margin-top: 50px;
        width: 1060px;
    }
    .kpiContainer{
        display: block;
        float: left;
        height: 160px;
        width: 235px;
        margin: 14px;
        border-radius: 15px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
    }
    .splitContainer{
        display: block;
        float: left;
        width: 50%;
        height: 100%;
    }
    .topProduct{
        background-image:linear-gradient(270deg, #ff7600, #fa9842);
    }
    .kpiHeader{
        margin: 15px;
        font-size: 15px;
        color: white;
        font-family: 'Exo', sans-serif;
    }
    .kpiHeaderNormal{
        margin: 15px;
        font-size: 15px;
        color: #353736;
        font-family: 'Exo', sans-serif;
    }
    .kpiClicks{
        margin: 15px;
        font-size: 25px;
        font-weight: bolder;
        color: white;
        text-align: center;
        font-family: 'Exo', sans-serif;
    }
    .kpi{
        margin-top: 20px;
        margin-bottom: 10px;
        font-size: 35px;
        color: #353736;
        font-family: 'Exo', sans-serif; 
        text-align: center;
        font-weight: 999;
    }
    .kpiVariation{
        font-size: 18px;
        color: rgb(12, 194, 12);
        font-family: 'Exo', sans-serif; 
        text-align: center;
        font-weight: 999;
    }
    .kpiDescription{
        margin-left: 15px;
        margin-right: 145px;
        margin-top: -10px;
        font-size: 11px;
        color: #353736;
        font-family: 'Exo', sans-serif;
    }
    .statisticImage{
        padding-top: 20px;
        padding-left: 20px;
        padding-right: 20px;
        object-fit: scale-down;
        width: 323px;
    }
    .productImageSize{
        background-color: white;
        border-radius: 5px;
        width: 110px;
        height: 110px;
        margin-top: 25px;
        object-fit: scale-down;
        padding: 5px;
    }
    .containerSplit{
        height: 40px;
        margin-top: 20px;
        padding-right: 20px;
        padding-left: 20px;
    }
    .splitHeaderLeft{
        width: 50%;
        text-align: left;
        display: block;
        float: left;
    }
    .splitHeaderRight{
        display: block;
        float: right;
        width: 50%;
        text-align: right;
    }    
    .distribute{
        background-image: linear-gradient(270deg, #ff7600, #fa9842);
        border-radius:10px ;
        height: 35px;
        margin-right:20px ;
        margin-left:20px ;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
        padding: 8px;
        color: white;
        margin-top: -10px;
    }   
    .statisticContainer{
        display: block;
        float: left;
        height: 360px;
        width: 323px;
        margin: 14px;
        border-radius: 15px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
    }
    .interestsDashboard{
        margin-top: -20px;
        object-fit: scale-down;
    }
    .dummy{
        width: 323px;
        padding: 10px;
    }
    .dashboardinactiv{
        background: #333333;
        opacity: 0.6;
        border-radius: 10px;
        width: 100%;
        height: 100%;
        margin-left: -250px;
        margin-top: -50px;
        position: fixed;
        
      
    }
    .screenCenter{
        
        color: white;
        margin-top: 250px;
        padding-left: 330px;
        width: 100%;
        text-align: center;
        
    }
</style>